<template>
    <a class="rn-badge d-none d-md-block" href="https://saysimple.releasenotes.io">
        <b-avatar
            id="release-notes-avatar"
            v-b-tooltip.hover.bottom="$t('popup.message')"
            class="avatar-link-button mr-1"
            rounded
        >
            <font-awesome-icon :icon="['fas', 'gift']" class="release-notes-icon" />
        </b-avatar>
    </a>
</template>

<script>
import i18n from "@/libs/i18n";
import { BAvatar, VBTooltip } from "bootstrap-vue";

export default {
    setup() {
        // Copied from the installation guide of
        // https://releasenotes.io/ with some slight changes.
        (function (w, d, s, o, f, js, fjs) {
            w["ReleaseNotesWidget"] = o;
            w[o] =
                w[o] ||
                function () {
                    (w[o].q = w[o].q || []).push(arguments);
                };
            (js = d.createElement(s)), (fjs = d.getElementsByTagName(s)[0]);
            js.id = o;
            js.src = f;
            js.async = 1;
            fjs.parentNode.insertBefore(js, fjs);
        })(window, document, "script", "rnw", "https://s3.amazonaws.com/cdn.releasenotes.io/v1/bootstrap.js");

        rnw("init", {
            account: "saysimple.releasenotes.io",
            selector: ".rn-badge", // changes the selector to apply the badge and link to
            title: i18n.t("release-notes.title"), // changes the CSS main title
            auto_show_unseen: false, // if enabled, the release notes will auto open if the user has unseen releases
            headerClass: "mx-auto",
        });
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    components: {
        BAvatar,
    },
};
</script>

<style lang="scss">
// This cannot be scoped .rnw-count is an external class so a scoped style component wont have effect on this

@import "~@/assets/scss/variables/_variables.scss";

.rnw-count {
    font-size: 0 !important;
    top: 8px !important;
    right: 21px !important;
    border: 2px solid $release-notes-button-border !important;
    background-color: $additional !important;
    width: 8px !important;
    height: 8px !important;
}
</style>
